module.exports = __webpack_public_path__ + "static/media/detail_0007_t.c3a04463.jpg";